import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PropertyProvider } from './context/PropertyContext';
import AppErrorBoundary from './components/ui/AppErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppErrorBoundary>
    <PropertyProvider>
      <App />
    </PropertyProvider>
  </AppErrorBoundary>
);

reportWebVitals();
